import React from 'react';
import { Market } from '../../types/Market';

interface MarketTableProps {
  markets: Market[];
  loading: boolean;
  onEdit: (market: Market) => void;
  onDelete: (id: number) => void;
}

const MarketTable: React.FC<MarketTableProps> = ({ markets, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading markets...</p>
      </div>
    );
  }

  if (markets.length === 0) {
    return (
      <div className="empty-state">
        <p>No markets found. Click "Add New Market" to create one.</p>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Country</th>
            <th>ISO Code</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {markets.map((market) => (
            <tr key={market.id}>
              <td>{market.id}</td>
              <td>{market.country}</td>
              <td>{market.isoCode}</td>
              <td className="table-actions">
                <button 
                  className="edit-button action-button"
                  onClick={() => onEdit(market)}
                >
                  Edit
                </button>
                <button 
                  className="delete-button action-button"
                  onClick={() => market.id && onDelete(market.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MarketTable; 